export default __webpack_public_path__ + "static/news2-152635f3b62fc76b78d162b5de17b09f.jpg";